import ScalarCheckbox_vue_vue_type_script_setup_true_lang_default from "./ScalarCheckbox.vue.script.js";
//#region src/components/ScalarCheckboxInput/ScalarCheckbox.vue
var ScalarCheckbox_default = ScalarCheckbox_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarCheckbox_default as default };

//# sourceMappingURL=ScalarCheckbox.vue.js.map